import _ from 'lodash';
import moment from 'moment';
import {EVENTS, MODALS} from 'common/domain/constants';
import {STATES} from 'common/domain/states';
import {AA_MANAGER_MODAL_COACHMARK_CONFIG} from 'food-benefit.module/common/domain/constants';

const PERMISSION = {
  MANAGER: 'A',
};

class FoodBenefitManagerController {
  constructor
  (foodDelegationService,
   ManagerDataService,
   foodBenefitService,
   $scope,
   $rootScope,
   $window,
   FoodBenefitUserDataService,
   HelperDelegationsService,
   loadingMobileService,
   floatingActionButtonsService) {
    'ngInject';
    this.foodBenefitService = foodBenefitService;
    this.floatingActionButtonsService = floatingActionButtonsService;
    this.ManagerDataService = ManagerDataService;
    this.foodDelegationService = foodDelegationService;
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.UserDataService = FoodBenefitUserDataService;
    this.helperDelegations = HelperDelegationsService;
    this.loadingMobileService = loadingMobileService;
    this.isMobileApp = $window.innerWidth < 1024;
    this.loaded = false;
    this.employeeFilters = [];
    this.existFilters = false;
    this.delegation = {};
    this.coachmarkData = AA_MANAGER_MODAL_COACHMARK_CONFIG;
    this.hasEmployeePeriods = false;
  }

  $onInit() {
    this._initData();
    this.visitedDelegation = this.helperDelegations.getVisitDelegation(this.userId, PERMISSION.MANAGER);
    this.loadingMobileService.show();
    this.checkDelegations().then(() => {
      this.loaded = true;
    }).finally(() => this.loadingMobileService.hide());
    this.reloadData();
  }

  _initData() {
    this.userId = this._getIdEmployee();
    this.manager = this.ManagerDataService.getManager();
    this.rawEmployeePeriods = this.manager.employeesFoodBenefitPeriods;
    this._setApprovedDays(this.rawEmployeePeriods);
    this.searchEmployees = this._formatEmployeesToSearch();
    this.employeePeriods = this.rawEmployeePeriods;
    this._checkEmployeePeriodsNumber();
    this.employeeFilters = [];
    this.urlDestination = STATES.FOOD_BENEFIT.DELEGATE;
  }

  _setApprovedDays(periods) {
    periods.forEach(period => {
      const daysDifference = parseInt(period.daysDifference, 10) || 0;

      if (daysDifference > 0) {
        period.approvedDays = period.enjoymentDays - daysDifference;
      }

      if (daysDifference < 0) {
        period.approvedDays = period.enjoymentDays + (daysDifference * -1);
      }
    });
  }

  get modal() {
    const $modal = $(MODALS.WARNING_DELEGATION_MODAL);
    $modal.on('hidden.bs.modal', () => {
      this.helperDelegations.setVisitedDelegation(this.userId, PERMISSION.MANAGER);
    });
    return $modal;
  }

  _getIdEmployee() {
    return this.UserDataService.getEmployee().userId;
  }

  _formatEmployeesToSearch() {
    let employeeIdList = [];
    return this.manager.employeesFoodBenefitPeriods.filter((employee) => {
      let id = employee.employeeId;
      if (employeeIdList.indexOf(id) >= 0) {
        return false;
      }

      employeeIdList.push(id);
      return employee;
    });
  }

  onSearch() {
    return this.helperDelegations.onSearchEmployeeDelegations(this.searchEmployees);
  }

  onCleanSearch($event) {
    if (!this.isMobileApp) return;
    if ($event.searchText.length) return;
    this.employeeFilters = [];
    this.employeePeriods = angular.copy(this.rawEmployeePeriods);
    this._checkEmployeePeriodsNumber();
  }

  onSelectEmployeeSearch($event) {
    const employeeIdInFilters = this.employeeFilters.find((employee) => employee.employeeId === $event.employeeId);
    if (!employeeIdInFilters) this.employeeFilters.push($event);
    this.existFilters = true;
    this._updateFilters();
  }

  _updateFilters() {
    this.employeePeriods = this.rawEmployeePeriods.filter((employee) => {
      return this.employeeFilters.some((filter) => {
        return filter.employeeId === employee.employeeId;
      });
    });
  }

  onRemoveEmployeeFilter($event) {
    _.remove(this.employeeFilters, filter => filter.employeeId === $event.employeeId);
    if (this.employeeFilters.length === 0) {
      this.onCleanEmployeeFilters();
      return;
    }

    this._updateFilters();
  }

  onCleanEmployeeFilters() {
    this.employeeFilters.length = 0;
    this.existFilters = false;
    this.employeePeriods = this.rawEmployeePeriods;
    this._checkEmployeePeriodsNumber();
  }

  reloadData() {
    this.loadingMobileService.show();
    this.foodBenefitService.getManagerDataSync().then((managerData) => {
      this._resetData(managerData);
      this.rootScope.$broadcast(EVENTS.REFRESH_ON_FOOD_BENEFIT_MANAGER, { isReloaded: true });
      this.floatingActionButtonsService.run();
    }).finally(() => this.loadingMobileService.hide());
  }

  _resetData(managerData) {
    this.manager = managerData;
    this.rawEmployeePeriods = this.manager.employeesFoodBenefitPeriods;
    this._setApprovedDays(this.rawEmployeePeriods);
    this.employeePeriods = this.rawEmployeePeriods;
    this._checkEmployeePeriodsNumber();
    if (this.isMobileApp) {
      this.rootScope.$broadcast(EVENTS.BADGE_NUMBER, {badgeNumber: this.rawEmployeePeriods.length});
    }
  }

  checkDelegations() {
    this.loadingMobileService.show();
    return this.foodDelegationService.getDelegations(this.userId).then((delegations) => {
      this.delegationsObject = delegations;
      this.hasDelegations = this.delegationsObject.length > 0;
      this.findDelegation();
      this.showModalWarningDelegation();
    }, (error) => {
      this.delegationsErrorMessage = error.data.message;
      this.hasDelegations = false;
    }).finally(() => this.loadingMobileService.hide());
  }

  findDelegation() {
    const today = moment().format('YYYY-MM-DD');
    this.delegation = this.foodDelegationService
      .findDelegationActive(today, this.delegationsObject, PERMISSION.MANAGER);
  }

  showModalWarningDelegation() {
    let delegationEmpty = this.helperDelegations.isDelegationEmpty(this.delegation);
    if (this.visitedDelegation || delegationEmpty) {
      return;
    }

    this.modal.modal('show');
  }

  showEmployeeSearchTags() {
    return this.existFilters && !this.isMobileApp;
  }

  _checkEmployeePeriodsNumber() {
    this.hasEmployeePeriods = false;
    if(this.employeePeriods.length > 0) {
      this.hasEmployeePeriods = true;
    }
  }

  getClasses() {
    return {
      responsiveMobile: this.isMobileApp,
      'with-floating-action-buttons': this.isMobileApp
    };
  }

  getClassToManagerBar() {
    return {
      'responsiveMobile': this.isMobileApp,
      'no-requests': !this.hasEmployeePeriods,
    };
  }
}

export default FoodBenefitManagerController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/features/foodBenefitManager/foodBenefitManager.controller.js